import enUS from "./en-US";
import pt from "./pt-BR";

export default {
    "en-US": enUS,
    "pt-BR": pt
}